import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import ServicingDetails from '../../components/servicings/servicing-details'

import { fetchServicing, claimServicing, updateServicing } from '../../actions/servicings'
import { loadActivitiesForArea } from '../../actions/area-activities'
import { markServicingAsHighPriority, markServicingAsLowPriority } from '../../actions/servicings'
import { unpinComment } from '../../actions/comments'
import { fetchLabelsForLocation } from '../../actions/servicing-labels'
import { fetchWorkOrder } from '../../actions/work-orders'

const mapStateToProps = (state, ownProps) => {
  const servicing = state.servicings[ownProps.params.areaId]
  let transferable = false

  if (!servicing) return { loading: true }
  const workOrder = state.workOrders[servicing.workOrderId]
  const area = state.areas[servicing.area]
  const pinnedComment = area.pinnedComment ? state.comments[area.pinnedComment] : null

  if (workOrder && workOrder.hasOwnProperty('backlog')) {
    transferable = state.workOrders[servicing.workOrderId].backlog
  }

  return {
    ...servicing,
    area,
    pinnedComment,
    transferable,
    assignee: state.users[servicing.assignee],
    claimer: servicing.claimedBy,
    location: ownProps.location,
    labels: servicing.servicingLabels
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.params.areaId

  dispatch(fetchServicing(id))
    .then((action) => {
      const areaId = action.payload.entities.servicings[action.payload.result].area
      const workOrderId = action.payload.entities.servicings[action.payload.result].workOrderId

      dispatch(loadActivitiesForArea(areaId))
      return dispatch(fetchWorkOrder(workOrderId))
    })
    .then((action) => {
      const locationId = action.payload.entities.workOrders[action.payload.result].location

      dispatch(fetchLabelsForLocation(locationId))
    })

  return {
    toggleHighPriority (isHighPriority) {
      if (isHighPriority) {
        dispatch(markServicingAsHighPriority(id))
      } else {
        dispatch(markServicingAsLowPriority(id))
      }
    },

    toggleInProgress (isInProgress) {
      if (isInProgress) {
        dispatch(updateServicing(id, { status: 'open' }))
      } else {
        dispatch(updateServicing(id, { status: 'in_progress' }))
      }
    },

    toggleTemporarilyOccupied (isTemporarilyOccupied) {
      if (isTemporarilyOccupied) {
        dispatch(updateServicing(id, { status: 'open' }))
      } else {
        dispatch(updateServicing(id, { status: 'temporarily_occupied' }))
      }
    },

    toggleRequireImages (requiresImages) {
      dispatch(updateServicing(id, { requireImages: requiresImages }))
    },

    transferArea () {
      const url = `${ownProps.location.pathname}/transfer`

      dispatch(push(url))
    },

    claim () {
      dispatch(claimServicing(id))
    },

    unpinComment (event, commentId) {
      event.preventDefault()

      dispatch(unpinComment(commentId))
        .then(() => dispatch(fetchServicing(id)))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicingDetails)



// WEBPACK FOOTER //
// ./src/containers/servicings/servicing-details-container.js